import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { CustomersService } from '../../../../services/customers.service';
import { UsersService } from '../../../../services/users.service';
import { SwalService } from '../../../../shared/services/swal.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  // Campos mostrados en pantalla / editables
  public name: string | null = null;
  public email: string | null = null;
  public idcliente: string | null = null;
  public role: string | null = 'admin'; // rol legible para UI
  public password: string = '';
  public passwordConfirm: string = '';

  // bandera para saber si el usuario quiere cambiar contraseña
  public changePassword: boolean = false;

  // info cruda del usuario que vino del backend
  public data: any = {};

  // para activar/desactivar modo edición visual de cada campo
  editField: { [key: string]: boolean } = {
    name: false,
    password: false
  };

  constructor(
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private customersService: CustomersService,
    private usersService: UsersService,
    private sweetService: SwalService
  ) {}

  async ngOnInit(): Promise<void> {
    const role = localStorage.getItem("netride_user_role")

    this.role = role
    // 1. Traer clientes
    let clientsResponse = await this.customersService.getAll();
    clientsResponse = clientsResponse.data;

    // 2. Traer perfil logueado
    const profile = await this.authService.getProfile().toPromise();
    
    this.data = profile.user;
    
    // const user = await this.usersService.show(this.data.id);
    // 3. Poblar campos visibles/editables
    this.name = this.data.name;
    this.email = this.data.email;
    this.idcliente = clientsResponse.find(
      (c: any) => c.id === this.data.client_id
    )?.name || null;

    // Si en tu API viene algo como roles / rolName, puedes mapearlo aquí
    // this.role = this.data.roles?.[0]?.name || 'Usuario';

    // Aseguramos que no quede contraseñas iniciales en inputs
    this.password = '';
    this.passwordConfirm = '';
    this.changePassword = false;
  }

  // Cambia entre modo edición / guardar visual
  toggleEdit(field: string) {
    this.editField[field] = !this.editField[field];

    // al cerrarse edición de "name", actualizamos this.data.name
    if (!this.editField[field] && field === 'name') {
      this.data.name = this.name;
    }

    // si cierras edición de password, no guardamos aún;
    // el guardado real ocurre en saveAll()
  }

  // Construir el cuerpo tal como lo espera tu endpoint Laravel
  private buildPayloadForUpdate() {
    // OJO: tu endpoint necesita:
    // email (required)
    // client_id (nullable)
    // rolName (requerido para assignRole)
    // changePassword (boolean)
    // password y confirmPassword SOLO si changePassword === true

    // 1. Base obligatorio
    const payload: any = {
      email: this.email,
      client_id: this.data.client_id || null,
      rolName: this.role || 'admin',
      changePassword: this.changePassword,
      name: this.name
    };

    // 2. Si el usuario quiere cambiar la contraseña, añadimos password fields
    if (this.changePassword) {
      payload.password = this.password;
      payload.confirmPassword = this.passwordConfirm;
    }

    return payload;
  }

  // Guardar cambios en backend
  async saveAll() {
    // Validación mínima antes de mandar al backend
    if (!this.email || this.email.trim() === '') {
      console.error('El email es requerido');
      this.sweetService.error('El email es requerido');
      return;
    }

    if (this.changePassword) {
      if (!this.password || !this.passwordConfirm) {
        alert('Debes llenar ambas contraseñas');
        return;
      }

      if (this.password !== this.passwordConfirm) {
        alert('Las contraseñas no coinciden');
        return;
      }

      if (this.password.length < 5) {
        alert('La contraseña debe tener al menos 5 caracteres');
        return;
      }
    }

    // Actualiza también nombre localmente si quieres mandarlo después en otro endpoint
    // O si en el futuro agregas el campo "name" al update del backend
    // this.data.name = this.name;

    const body = this.buildPayloadForUpdate();

    this.usersService
      .update(body, this.data.id)
      .subscribe(
        res => {
          if(res['success']){
            this.sweetService.success();
          }
        },
        err => {
          console.error('❌ Error al actualizar', err);
        }
      );
  }

  // Cuando el usuario activa/desactiva "cambiar contraseña"
  onToggleChangePassword(checked: boolean) {
    this.changePassword = checked;

    if (!checked) {
      // limpiamos los campos de password si el usuario cancela
      this.password = '';
      this.passwordConfirm = '';
    }
  }

  // Resetear la vista a lo que vino del backend
  async reset() {
    await this.ngOnInit();
  }
}
